import * as React from 'react';

const OrbisMarkSVG = ({ size = 28, className = '' }) => {
  const scale = size / 56;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <circle cx="28" cy="28" r="22" stroke="var(--orbis-t1)" strokeWidth={0.9 / scale} fill="none" />
      <circle cx="28" cy="28" r="13.5" stroke="var(--orbis-t1)" strokeWidth={0.9 / scale} fill="none" />
      <circle cx="28" cy="28" r="5" fill="var(--orbis-t1)" />
      <ellipse cx="28" cy="28" rx="22" ry="8.5" stroke="var(--orbis-t1)" strokeWidth={0.9 / scale} fill="none" />
    </svg>
  );
};

const OrbisLogo = ({ size = 28, variant = 'full', className = '' }) => {
  if (variant === 'mark') {
    return <OrbisMarkSVG size={size} className={className} />;
  }

  return (
    <div className={`flex items-center gap-2.5 ${className}`}>
      <OrbisMarkSVG size={size} />
      <span
        style={{
          fontFamily: 'var(--orbis-font)',
          fontSize: '16px',
          fontWeight: 200,
          letterSpacing: '-0.045em',
          color: 'var(--orbis-t1)',
        }}
      >
        Orbis
      </span>
    </div>
  );
};

export { OrbisLogo, OrbisMarkSVG };
export default OrbisLogo;
